import {Component} from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-page-not-found-text',
  templateUrl: './page-not-found-right-panel.component.html',
  styleUrls: ['./page-not-found-right-panel.component.css']
})
export class PageNotFoundRightPanelComponent {
  constructor(
    private router: Router,
  ) {
  }

  homepage() {
    this.router.navigate([''])
  }
}
